module.exports = __webpack_public_path__ + "static/media/BF.c687a881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BF.svg
// module id = 2110
// module chunks = 7